import React from 'react'

// Images & Icons
import BlackWarningIcon from 'assets/icons/general/BlackWarningIcon.png'

function RegistrationInstructions() {
    const instructions = [
        {
            desc: "Fill in all sections clearly and carefully."
        },
        {
            desc: "Information requested on this form is for the national database and tracking purposes. It assists in ongoing qualification issuance as required."
        },
    ]

    return (
        <div className='bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <div className='flex flex-row gap-2 items-center p-4 text-sm sm:text-base md:text-lg border-2 rounded-lg border-orange-500 bg-orange-100'>
                <img
                    className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6"
                    src={BlackWarningIcon}
                    alt="question-mark-icon"
                />
                <p className='text-sm sm:text-base xl:text-xl'>Please read <a className="underline font-bold" href="/privacy-notice" target="_blank" rel="noopener noreferrer">
                    Privacy Notice</a> before filling out the form.</p>
            </div>
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>Instructions for Completion</p>
            <div className='space-y-4'>
                <ol className="list-decimal space-y-6 ml-4 text-justify text-sm sm:text-base xl:text-xl">
                    {instructions.map((instruction, i) => {
                        return (
                            <li key={i}>{instruction.desc}</li>
                        )
                    })}
                </ol>
            </div>
        </div>
    )
}

export default RegistrationInstructions